module.exports = __webpack_public_path__ + "static/media/WhatsApp.d54d864a.svg";